import { CaretDownOutlined } from "@ant-design/icons";
import { Row, Select, Tooltip } from "antd";
import React from "react";

export interface IFoamSelectProps {
  options: any[];
  currentValue: any;
  handleChangeFoam: Function;
}

const FoamSelect = (props: IFoamSelectProps) => {
  const { options, currentValue, handleChangeFoam } = props;
  return (
    <Row justify="center">
      <Tooltip
        title='Vui lòng chọn "chuẩn nâng đỡ phù hợp"'
        placement="top"
        color="#0c3b5d"
        align={{ offset: [0, 5] }}
        overlayStyle={{ maxWidth: "none" }}
        overlayInnerStyle={{ whiteSpace: "nowrap" }}>
        <Select
          virtual={false}
          value={currentValue}
          onChange={handleChangeFoam}
          optionLabelProp="label"
          className="product-item-select product-item-select--left"
          dropdownClassName="product-item-select__dropdown"
          dropdownAlign={{ points: ["tc", "bc"], offset: [0, 4] }}
          suffixIcon={
            <CaretDownOutlined
              style={{
                color: "#0c3b5d",
              }}
              className={"flicker-color"}
            />
          }>
          {Array.isArray(options) &&
            options.length &&
            options.map((item: any, index: number) => (
              <Select.Option
                key={index}
                value={item.kde_pro_spec_id}
                label={
                  <span className="product-item-select__label">
                    {item.extra_name}
                  </span>
                }
                className="product-item-select__option">
                <span className="product-item-select__label">
                  <span className="product-item-select__option-name">
                    {item.extra_name}
                  </span>
                  : {item.description}
                </span>
              </Select.Option>
            ))}
        </Select>
      </Tooltip>
    </Row>
  );
};

export default FoamSelect;
